import { Component, OnInit } from '@angular/core';
import { ProfileService } from '../../../services/profile.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-notification-box',
  templateUrl: './notification-box.component.html',
  styleUrls: ['./notification-box.component.scss']
})
export class NotificationBoxComponent implements OnInit {

    constructor(private _router: Router, public profileService: ProfileService, private _authentication: AuthenticationService) { }
    public openNotification: boolean = false;
    ngOnInit(): void {
        this.getUnreadNotificationCount();
    }
    showMoreNotification() {
        this._router.navigate(['/home/notification']);
    }
    toggleNotificationMobile() {
        this.openNotification = !this.openNotification;
    }
    getUnreadNotificationCount() {
        this.profileService.getUnreadNotificationCount(this._authentication._authentication.id).subscribe(
            (res: any) => {
                if (res.success) {
                    this.profileService.UnreadNotificationsCount = res.data;
                }
                else {
                    console.error("getUnreadNotificationCount", res.error_message);
                }
            },
            (err: any) => {
                console.error("getUnreadNotificationCount", err);
            }
        );

    }
}
